/**
 * Csv Schema of TypeSms
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {TypeSms} from '@/model/resource/TypeSms'

/* TODO: review generated schema */
export class CsvTypeSmsSchema extends Schema {
  readonly name = 'CsvTypeSms'

  readonly fieldSet: FieldSet<TypeSms> = {
    idTypePk: schema => schema.model.idTypePk,
    ativo: schema => Helper.bool(schema.model.ativo),
    nome: schema => schema.model.nome,
  }
}
